// RequirePrivilege.jsx
import { Navigate } from "react-router-dom";
import { getUserPrivileges, getUserRole } from "../utils/auth";

const RequirePrivilege = ({ anyOf = [], children }) => {
  const role = getUserRole();
  const privileges = getUserPrivileges();

  // ✅ ADMIN ALWAYS ALLOWED
  if (role === "admin") {
    return children;
  }

  // ✅ Any ONE privilege is enough
  const allowed = anyOf.some(p => privileges.includes(p));

  if (allowed) {
    return children;
  }

  return <Navigate to="/unauthorized" replace />;
};

export default RequirePrivilege;
